import React from 'react'
import { Input as InputAnt } from 'antd'
import { InputProps } from 'antd/lib/input'

import { useT } from 'src/core/hooks/use-translation'

function Input({
  allowClear = true,
  children,
  placeholder,
  ...props
}: InputProps & { children?: any }) {
  const { t } = useT()
  return (
    <InputAnt {...props} allowClear={allowClear} placeholder={t(placeholder)}>
      {children}
    </InputAnt>
  )
}

export default Input
